import { HttpHeaders, HttpParams } from "@angular/common/http";
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { DocumentTemplate } from "src/app/shared/models/document-template.model";
import { DocumentTemplateGetAll } from "../models/document-template-get-all.model";
import { BehaviorSubject, Observable } from "rxjs";
import { Response } from 'src/app/shared/models/response.model';
import { DataWithPage } from 'src/app/shared/models/data-with-page.model';
import { FormData } from 'src/app/shared/models/form-data.model';

const API_GET_DOCUMENT_TEMPLATE = "/dc/document-type-enterprises/get-all";
const API_SAVE_DOCUMENT_TEMPLATE = "/dc/document-type-enterprises/save";
const API_GET_DOCUMENT_TEMPLATE_BY_ID = "/dc/document-type-enterprises/get-by-id/";
const API_DELETE_DOCUMENT_TEMPLATE = "/dc/document-type-enterprises/delete/";
const API_GENERATE_FORM = "/dc/document-type-enterprises/generate-form/";
const API_COPY_DOCUMENT_TEMPLATE = "/dc/document-type-enterprises/copy/";
const API_GET_SIGNATURE = "/dc/document-type-enterprises/get-signatures/";
const API_GET_SIGNATURE_POSITIONS = "/dc/document-type-enterprises/get-signatures-positions/";
const API_CHECK_LOT_TEMPLATE = "/dc/document-type-enterprises/check-lot-template/";
const API_GET_INTERNAL_USER_BY_TEMPLATE_ID = "/dc/document-type-enterprises/get-by-id/";
const API_SAVE_INTERNAL_USER_BY_TEMPLATE_ID = "/dc/document-type-enterprises/get-by-id/";
const API_ACTIVE_DOCUMENT_TEMPLATE = "/dc/document-type-enterprises/active";
@Injectable({
  providedIn: "root",
})
export class DocumentTemplateService {
  constructor(private apiService: ApiService) { }

  typeforUpdateDocumentPage = new BehaviorSubject<string>('');
  downloadTemplateSuccess = new BehaviorSubject<boolean>(false);
  getDocumentTemplate(body: any = {}): Observable<Response<DataWithPage<Array<DocumentTemplate>>>> {
    return this.apiService.post(API_GET_DOCUMENT_TEMPLATE, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  saveDocumentTemplate(body: any){
    return this.apiService.post(API_SAVE_DOCUMENT_TEMPLATE, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  activeDocumentTemplate(body: any){
    return this.apiService.post(API_ACTIVE_DOCUMENT_TEMPLATE, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getDocumentTemplateById(id: string): Observable<Response<DocumentTemplate>> {
    return this.apiService
      .get(`${API_GET_DOCUMENT_TEMPLATE_BY_ID}${id}`)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  deleteDocumentTemplate(id: string): Observable<Response<string>> {
    return this.apiService.get(`${API_DELETE_DOCUMENT_TEMPLATE}${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  genForm(id: string): Observable<Response<FormData>> {
    return this.apiService.get(`${API_GENERATE_FORM}${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  copyDocumentTemplate(id: string, type: 'SYNC' | null = null) {
    return this.apiService.get(`${API_COPY_DOCUMENT_TEMPLATE}${id}` + (type ? `?type=${type}` : '')).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getSignature(id: string) {
    return this.apiService.get(`${API_GET_SIGNATURE}${id}`).pipe(
      map(res => {
        return res;
      })
    )
  }

  getSignaturePosition(body: any, id: string) {
    return this.apiService.post(`${API_GET_SIGNATURE_POSITIONS}${id}`, body).pipe(
      map(res => {
        return res;
      })
    )
  }

  checkLotTemplate(id: string) {
    return this.apiService.get(`${API_CHECK_LOT_TEMPLATE}${id}`).pipe(
      map(res => {
        return res;
      })
    )
  }

  getInternalUserByTemplateId(id: any): Observable<Response<DocumentTemplate>> {
    return this.apiService
      .get(`${API_GET_INTERNAL_USER_BY_TEMPLATE_ID}${id}`)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  saveInternalUserByTemplateId(body: any): Observable<Response<DocumentTemplate>> {
    return this.apiService
      .post(API_SAVE_INTERNAL_USER_BY_TEMPLATE_ID, body)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
}
